import React, { useState } from 'react';
import styled from 'styled-components';
import { useModalStore } from '../../../shared/store/portal/modalStore';
import { slideInFromRightWeighted } from '../../../shared/component/Animation';
import HeadlessBtn from '../../../shared/component/headless/button/HeadlessBtn';
import { BlackFullWidthBtn } from '../../../shared/component/headless/button/BtnBody';
import { VenueFilterData } from '../../../shared/dto/EntityRepository';
import { getModalMessage } from '../../../shared/constants/modalMessages';
import { getBtnName } from '../../../shared/constants/btnNames';
import { paperTextureModal } from '../../../shared/component/paperTexture';
import { useAdminVenueStore } from '../../share/store/adminVenueStore';
import FilterStationVenueType from './FilterStationVenueType';
import FilterStationVenueAdmission from './FilterStationVenueAdmission';
import FilterStationVenueOpenToday from './FilterStationVenueOpenToday';
import FilterStationVenueDistrict from './FilterStationVenueDistrict';
import { runAfterVenueListContextChange } from './runAfterUnsavedVenueCheck';

const FilterStationVenueModal: React.FC = () => {
  const { isClosing, clearModal } = useModalStore();
  const filterData = useAdminVenueStore((state) => state.filterData);
  const setFilterData = useAdminVenueStore((state) => state.setFilterData);
  const [currentFilter, setCurrentFilter] = useState<VenueFilterData>(filterData);

  if (!filterData) return null;

  const handleSubmit = () => {
    runAfterVenueListContextChange(() => {
      setFilterData(currentFilter);
      clearModal(400);
    });
  };

  return (
    <RightModalFrame
      onClick={(e) => e.stopPropagation()}
      $isClosing={isClosing}
    >
      <FilterStationComp>
        <FilterStationTitle>{getModalMessage('FILTER_STATION_TITLE')}</FilterStationTitle>
        <FilterStationVenueType
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationVenueAdmission
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationVenueOpenToday
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <FilterStationVenueDistrict
          currentFilter={currentFilter}
          setCurrentFilter={setCurrentFilter}
        />
        <HeadlessBtn
          value={getBtnName('APPLY')}
          handleClick={handleSubmit}
          StyledBtn={ApplyButton}
        />
      </FilterStationComp>
    </RightModalFrame>
  );
};

export default FilterStationVenueModal;

const RightModalFrame = styled.div<{ $isClosing: boolean }>`
  position: absolute;
  right: clamp(20px, 2vw, 30px);
  bottom: clamp(70px, 10vh, 100px);
  width: 22vw;
  min-width: 300px;
  height: clamp(55vh, fit-content, 90vh);

  padding: 20px;

  opacity: ${({ $isClosing }) => ($isClosing ? 0 : 1)};
  transform: ${({ $isClosing }) =>
    $isClosing
      ? 'translateX(100%)'
      : 'translateX(0)'
  };

  transition: all 0.6s ease-out;
  ${paperTextureModal}
  ${slideInFromRightWeighted}
`;

const FilterStationComp = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: clamp(10px, 3vh, 20px);
`;

const FilterStationTitle = styled.div`
  margin-bottom: 1.5vh;
  ${({ theme }) => theme.typography.Body_02_1};
`;

const ApplyButton = styled(BlackFullWidthBtn)`
  margin: 10px 0px;
`;
